"use strict";

exports.__esModule = true;
exports.GoalsByPhases = exports.LiveTime = exports.MatchStatusIndicator = exports.LiveScore = exports.TeamLogo = exports.TeamName = exports.Team = exports.MatchWrapper = void 0;

var tslib_1 = require("tslib");

var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");

var date_fns_1 = require("date-fns");

var sk_1 = tslib_1.__importDefault(require("date-fns/locale/sk"));

var polished_1 = require("polished");

var React = tslib_1.__importStar(require("react"));

var socketConnect = tslib_1.__importStar(require("socket.io-client"));

var sportnet_utilities_1 = require("sportnet-utilities");

var styled_components_1 = require("styled-components");

var CompetitionsApi_1 = tslib_1.__importDefault(require("../../../api/CompetitionsApi"));

var setupApis_1 = require("../../../api/setupApis");

var _config_1 = tslib_1.__importDefault(require("../../../config"));

var styled_components_2 = tslib_1.__importDefault(require("../../../theme/styled-components"));

var TimeLine_1 = require("../MatchDetail/TimeLine");

setupApis_1.setupCompetitionsApi();
var GoalsOverview = styled_components_2["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n  width: 100%;\n  display: none;\n  ", " {\n    display: flex;\n  }\n"], ["\n  font-size: ", ";\n  width: 100%;\n  display: none;\n  ", " {\n    display: flex;\n  }\n"])), polished_1.rem(11), utilities_1.mb('m'));
var GoalsOverviewTeamCol = styled_components_2["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  width: 50%;\n  display: flex;\n  padding: 0 ", ";\n  flex-direction: column;\n"], ["\n  width: 50%;\n  display: flex;\n  padding: 0 ", ";\n  flex-direction: column;\n"])), polished_1.rem(10));
var GoalsOverviewPlayer = styled_components_2["default"].div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: ", " 0px;\n"], ["\n  display: flex;\n  align-items: center;\n  padding: ", " 0px;\n"])), polished_1.rem(5));
var GoalsOverviewPlayerName = styled_components_2["default"].div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject([""], [""])));
var GoalsOverviewHomeTeamCol = styled_components_2["default"](GoalsOverviewTeamCol)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  align-items: flex-end;\n  border-right: ", " dotted ", ";\n  ", " {\n    padding-right: ", ";\n  }\n"], ["\n  align-items: flex-end;\n  border-right: ", " dotted ", ";\n  ", " {\n    padding-right: ", ";\n  }\n"])), polished_1.rem(1), function (_a) {
  var theme = _a.theme;
  return theme.separatorColor;
}, GoalsOverviewPlayerName, polished_1.rem(10));
var GoalsOverviewAwayTeamCol = styled_components_2["default"](GoalsOverviewTeamCol)(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  align-items: flex-start;\n  ", " {\n    flex-direction: row-reverse;\n  }\n  ", " {\n    padding-left: ", ";\n  }\n"], ["\n  align-items: flex-start;\n  ", " {\n    flex-direction: row-reverse;\n  }\n  ", " {\n    padding-left: ", ";\n  }\n"])), GoalsOverviewPlayer, GoalsOverviewPlayerName, polished_1.rem(10));
exports.MatchWrapper = styled_components_2["default"].div(templateObject_13 || (templateObject_13 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  ", ";\n  height: 100%;\n  ", "\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  ", ";\n  height: 100%;\n  ", "\n  ", "\n"])), function (_a) {
  var matchSize = _a.matchSize;

  if (matchSize) {
    return styled_components_1.css(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n        width: ", ";\n      "], ["\n        width: ", ";\n      "])), polished_1.rem(matchSize));
  }

  return styled_components_1.css(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n      width: 100%;\n    "], ["\n      width: 100%;\n    "])));
}, function (_a) {
  var lastIndex = _a.lastIndex,
      fullWidth = _a.fullWidth,
      compact = _a.compact,
      theme = _a.theme;

  if (compact) {
    return styled_components_1.css(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject(["\n        width: 100%;\n      "], ["\n        width: 100%;\n      "])));
  }

  if (!lastIndex && !fullWidth) {
    return styled_components_1.css(templateObject_10 || (templateObject_10 = tslib_1.__makeTemplateObject(["\n        border-right: ", " solid ", ";\n      "], ["\n        border-right: ", " solid ", ";\n      "])), polished_1.rem(1), theme.separatorColor);
  }

  return styled_components_1.css(templateObject_11 || (templateObject_11 = tslib_1.__makeTemplateObject([""], [""])));
}, function (_a) {
  var verbose = _a.verbose,
      theme = _a.theme;

  if (verbose) {
    return utilities_1.mb('m') + " {\n        position: relative;\n        padding: " + polished_1.rem(20) + ";\n        margin: auto;\n        " + exports.TeamLogo + " {\n          max-height: " + polished_1.rem(150) + ";\n          max-width: 100%;\n        }\n        " + exports.TeamName + " {\n          font-size: " + polished_1.rem(17) + ";\n          padding-top: " + polished_1.rem(10) + ";\n        }\n        " + exports.LiveScore + " {\n          font-size: " + polished_1.rem(38) + ";\n        }\n        " + exports.MatchStatusIndicator + " {\n          font-size: " + polished_1.rem(11) + ";\n        }\n        " + exports.GoalsByPhases + " {\n          font-size: " + polished_1.rem(12) + ";\n        }\n        " + MatchDate + " {\n          display: block;\n        }\n        " + MatchTime + " {\n          display: block;\n        }\n      }";
  }

  return styled_components_1.css(templateObject_12 || (templateObject_12 = tslib_1.__makeTemplateObject([""], [""])));
});
exports.Team = styled_components_2["default"].div(templateObject_17 || (templateObject_17 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  flex-direction: column;\n  width: 30%;\n  height: 100%;\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  flex-direction: column;\n  width: 30%;\n  height: 100%;\n  ", "\n"])), function (_a) {
  var align = _a.align,
      compact = _a.compact;

  if (compact && align === 'left') {
    return styled_components_1.css(templateObject_14 || (templateObject_14 = tslib_1.__makeTemplateObject(["\n        flex-direction: row-reverse;\n        justify-content: right;\n        width: 40%;\n        ", " {\n          text-align: right !important;\n        }\n      "], ["\n        flex-direction: row-reverse;\n        justify-content: right;\n        width: 40%;\n        ", " {\n          text-align: right !important;\n        }\n      "])), exports.TeamName);
  } else if (compact && align === 'right') {
    return styled_components_1.css(templateObject_15 || (templateObject_15 = tslib_1.__makeTemplateObject(["\n        flex-direction: row;\n        width: 40%;\n        justify-content: left;\n        ", " {\n          text-align: left !important;\n        }\n      "], ["\n        flex-direction: row;\n        width: 40%;\n        justify-content: left;\n        ", " {\n          text-align: left !important;\n        }\n      "])), exports.TeamName);
  }

  return styled_components_1.css(templateObject_16 || (templateObject_16 = tslib_1.__makeTemplateObject([""], [""])));
});
exports.TeamName = styled_components_2["default"].div(templateObject_18 || (templateObject_18 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n  font-weight: bold;\n  color: ", ";\n  text-transform: uppercase;\n  padding: 0 ", ";\n  text-align: center;\n"], ["\n  font-size: ", ";\n  font-weight: bold;\n  color: ", ";\n  text-transform: uppercase;\n  padding: 0 ", ";\n  text-align: center;\n"])), polished_1.rem(10), function (_a) {
  var theme = _a.theme;
  return theme.app.textColor;
}, polished_1.rem(10));
exports.TeamLogo = styled_components_2["default"].img(templateObject_19 || (templateObject_19 = tslib_1.__makeTemplateObject(["\n  max-height: ", ";\n  padding: 0 ", ";\n  margin: ", " 0;\n"], ["\n  max-height: ", ";\n  padding: 0 ", ";\n  margin: ", " 0;\n"])), polished_1.rem(30), polished_1.rem(10), polished_1.rem(10));
exports.LiveScore = styled_components_2["default"].div(templateObject_22 || (templateObject_22 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n  padding: ", " ", ";\n  width: 40%;\n  text-align: center;\n  font-weight: bold;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  ", "\n"], ["\n  font-size: ", ";\n  padding: ", " ", ";\n  width: 40%;\n  text-align: center;\n  font-weight: bold;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  ", "\n"])), polished_1.rem(21), polished_1.rem(5), polished_1.rem(10), function (_a) {
  var compact = _a.compact;

  if (compact) {
    return styled_components_1.css(templateObject_20 || (templateObject_20 = tslib_1.__makeTemplateObject(["\n        width: 20%;\n      "], ["\n        width: 20%;\n      "])));
  }

  return styled_components_1.css(templateObject_21 || (templateObject_21 = tslib_1.__makeTemplateObject([""], [""])));
});
exports.MatchStatusIndicator = styled_components_2["default"].div(templateObject_23 || (templateObject_23 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n  color: ", ";\n  text-transform: uppercase;\n  padding-top: ", ";\n"], ["\n  font-size: ", ";\n  color: ", ";\n  text-transform: uppercase;\n  padding-top: ", ";\n"])), polished_1.rem(9), function (_a) {
  var color = _a.color;
  return color;
}, polished_1.rem(5));
exports.LiveTime = styled_components_2["default"].div(templateObject_24 || (templateObject_24 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n  color: ", ";\n  font-weight: normal;\n"], ["\n  font-size: ", ";\n  color: ", ";\n  font-weight: normal;\n"])), polished_1.rem(11), function (_a) {
  var theme = _a.theme;
  return theme.color.danger;
});
exports.GoalsByPhases = styled_components_2["default"].div(templateObject_25 || (templateObject_25 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n  font-weight: normal;\n"], ["\n  font-size: ", ";\n  font-weight: normal;\n"])), polished_1.rem(11));
var MatchDate = styled_components_2["default"].div(templateObject_26 || (templateObject_26 = tslib_1.__makeTemplateObject(["\n  font-weight: 300;\n  font-size: ", ";\n  display: none;\n"], ["\n  font-weight: 300;\n  font-size: ", ";\n  display: none;\n"])), polished_1.rem(17));
var MatchTime = styled_components_2["default"].div(templateObject_27 || (templateObject_27 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n  font-weight: 400;\n  display: none;\n"], ["\n  font-size: ", ";\n  font-weight: 400;\n  display: none;\n"])), polished_1.rem(15));
var MatchSportGround = styled_components_2["default"].div(templateObject_28 || (templateObject_28 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n  font-weight: 300;\n"], ["\n  font-size: ", ";\n  font-weight: 300;\n"])), polished_1.rem(14));

var Match =
/** @class */
function (_super) {
  tslib_1.__extends(Match, _super);

  function Match() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      live: {
        timer: {},
        liveState: {
          ongoing: false,
          seconds: 0,
          phase: '',
          startDate: '',
          eventDate: ''
        },
        protocol: {
          events: []
        }
      }
    };
    _this.timerEvent = null;

    _this.getTeam = function (teamSide) {
      return _this.props.match.teams.find(function (i) {
        return sportnet_utilities_1.getProp(i, ['additionalProperties', 'homeaway'], '') === teamSide;
      });
    };

    _this.getTeamsIds = function () {
      var homeTeam = _this.getTeam('home');

      var homeTeamId = homeTeam ? homeTeam._id : _this.props.match.teams[0]._id;

      var awayTeam = _this.getTeam('away');

      var awayTeamId = awayTeam ? awayTeam._id : _this.props.match.teams[1]._id;
      return {
        homeTeamId: homeTeamId,
        awayTeamId: awayTeamId
      };
    };

    _this.getShootoutGoals = function () {
      var match = _this.props.match;

      var _a = _this.getTeamsIds(),
          homeTeamId = _a.homeTeamId,
          awayTeamId = _a.awayTeamId;

      var homeTeamGoals = 0;
      var awayTeamGoals = 0;

      if (sportnet_utilities_1.getProp(_this.state, ['live', 'protocol', 'events'], []).length) {
        homeTeamGoals = (_this.state.live.protocol.events || []).reduce(function (acc, e) {
          if (e.team === homeTeamId && e.eventType === 'goal' && e.phase === 'shootout') {
            return acc + 1;
          }

          return acc;
        }, homeTeamGoals);
        awayTeamGoals = (_this.state.live.protocol.events || []).reduce(function (acc, e) {
          if (e.team === awayTeamId && e.eventType === 'goal' && e.phase === 'shootout') {
            return acc + 1;
          }

          return acc;
        }, awayTeamGoals);
      } else if (match.protocol) {
        homeTeamGoals = match.protocol.events.reduce(function (acc, e) {
          if (e.team === homeTeamId && e.eventType === 'goal' && e.phase === 'shootout') {
            return acc + 1;
          }

          return acc;
        }, homeTeamGoals);
        awayTeamGoals = match.protocol.events.reduce(function (acc, e) {
          if (e.team === awayTeamId && e.eventType === 'goal' && e.phase === 'shootout') {
            return acc + 1;
          }

          return acc;
        }, awayTeamGoals);
      }

      return {
        homeTeamGoals: homeTeamGoals,
        awayTeamGoals: awayTeamGoals
      };
    };

    _this.getGoalsByTeams = function () {
      var match = _this.props.match;

      var _a = _this.getTeamsIds(),
          homeTeamId = _a.homeTeamId,
          awayTeamId = _a.awayTeamId;

      var homeTeamGoals = 0;
      var awayTeamGoals = 0;

      if (sportnet_utilities_1.getProp(_this.state, ['live', 'protocol', 'events'], []).length) {
        homeTeamGoals = (_this.state.live.protocol.events || []).reduce(function (acc, e) {
          if (e.team === homeTeamId && e.eventType === 'goal' && e.type !== 'dropped' && e.phase !== 'shootout' || e.team === awayTeamId && e.eventType === 'goal' && e.type === 'dropped') {
            return acc + 1;
          }

          return acc;
        }, homeTeamGoals);
        awayTeamGoals = (_this.state.live.protocol.events || []).reduce(function (acc, e) {
          if (e.team === awayTeamId && e.eventType === 'goal' && e.type !== 'dropped' && e.phase !== 'shootout' || e.team === homeTeamId && e.eventType === 'goal' && e.type === 'dropped') {
            return acc + 1;
          }

          return acc;
        }, awayTeamGoals);
      } else if (match.protocol) {
        homeTeamGoals = match.protocol.events.reduce(function (acc, e) {
          if (e.team === homeTeamId && e.eventType === 'goal' && e.phase !== 'shootout' && e.type !== 'dropped' || e.team === awayTeamId && e.eventType === 'goal' && e.type === 'dropped') {
            return acc + 1;
          }

          return acc;
        }, homeTeamGoals);
        awayTeamGoals = match.protocol.events.reduce(function (acc, e) {
          if (e.team === awayTeamId && e.eventType === 'goal' && e.phase !== 'shootout' && e.type !== 'dropped' || e.team === homeTeamId && e.eventType === 'goal' && e.type === 'dropped') {
            return acc + 1;
          }

          return acc;
        }, awayTeamGoals);
      }

      return {
        homeTeamGoals: homeTeamGoals,
        awayTeamGoals: awayTeamGoals
      };
    };

    _this.getGoalsByMatchPart = function (events) {
      var _a = _this.getTeamsIds(),
          homeTeamId = _a.homeTeamId,
          awayTeamId = _a.awayTeamId;

      var phases = _this.props.sportSectorsPhases.find(function (i) {
        return i._id === _this.props.match.rules.sport_sector;
      });

      return events.reduce(function (acc, event) {
        var _a, _b, _c, _d;

        if (event.eventType === 'goal' && event.phase !== 'shootout') {
          var otherTeamId = event.team === homeTeamId ? awayTeamId : homeTeamId;

          if (event.type === 'dropped') {
            return tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[event.phase] = tslib_1.__assign(tslib_1.__assign({}, acc[event.phase]), (_b = {}, _b[otherTeamId] = (acc[event.phase] ? acc[event.phase][otherTeamId] || 0 : 0) + 1, _b)), _a));
          }

          return tslib_1.__assign(tslib_1.__assign({}, acc), (_c = {}, _c[event.phase] = tslib_1.__assign(tslib_1.__assign({}, acc[event.phase]), (_d = {}, _d[event.team] = (acc[event.phase] ? acc[event.phase][event.team] || 0 : 0) + 1, _d)), _c));
        }

        return acc;
      }, phases ? phases.items.reduce(function (acc, phase) {
        var _a, _b;

        if (sportnet_utilities_1.getProp(_this.props, ['match', 'timer', phase._id, 'start', 'date'])) {
          return tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[phase._id] = (_b = {}, _b[homeTeamId] = 0, _b[awayTeamId] = 0, _b), _a));
        }

        return acc;
      }, {}) : {});
    };

    _this.getCurrentMatchStatus = function (matchId) {
      return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var currentState;
        return tslib_1.__generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , CompetitionsApi_1["default"].getMatch(matchId)];

            case 1:
              currentState = _a.sent();

              if (currentState.liveState) {
                this.setState({
                  live: {
                    liveState: currentState.liveState,
                    timer: currentState.timer || {},
                    protocol: tslib_1.__assign(tslib_1.__assign({}, currentState.protocol || {}), {
                      events: currentState.protocol ? currentState.protocol.events || [] : []
                    })
                  }
                });
              }

              return [2
              /*return*/
              ];
          }
        });
      });
    };

    _this.registerLiveScore = function (matchId) {
      return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var _this = this;

        return tslib_1.__generator(this, function (_a) {
          this.setState({
            live: {
              liveState: this.props.match.liveState || this.state.live.liveState,
              timer: this.props.match.timer || this.state.live.timer,
              protocol: tslib_1.__assign(tslib_1.__assign({}, this.props.match.protocol || {}), {
                events: this.props.match.protocol ? this.props.match.protocol.events : []
              })
            }
          }, function () {
            _this.registerTimer();

            var socket = socketConnect["default"]('https://sutaze.sportnet.online', {
              path: '/api/v1/socket.io'
            });
            socket.on("match_livestate_" + matchId, function (response) {
              _this.setState({
                live: tslib_1.__assign(tslib_1.__assign({}, _this.state.live), response)
              }, function () {
                _this.registerTimer();

                if (_this.props.onLiveScoreChange) {
                  _this.props.onLiveScoreChange(tslib_1.__assign(tslib_1.__assign({}, _this.state.live), response));
                }
              });
            });
          });
          this.getCurrentMatchStatus(matchId);
          return [2
          /*return*/
          ];
        });
      });
    };

    _this.registerTimer = function () {
      if (_this.timerEvent) {
        clearInterval(_this.timerEvent);
        _this.timerEvent = 1;
      }

      _this.forceUpdate();

      if (_this.state.live.liveState.ongoing) {
        _this.timerEvent = setInterval(function () {
          var secondsToAdd = _this.props.settings.reverseTime ? _this.state.live.liveState.seconds - 1 : _this.state.live.liveState.seconds + 1;
          var updateData = {
            live: tslib_1.__assign(tslib_1.__assign({}, _this.state.live), {
              liveState: tslib_1.__assign(tslib_1.__assign({}, _this.state.live.liveState), {
                seconds: secondsToAdd
              })
            })
          };

          _this.setState(updateData);
        }, 1000);
      }
    };

    _this.renderContumatedMatchScore = function (match) {
      var _a = _this.getTeamsIds(),
          homeTeamId = _a.homeTeamId,
          awayTeamId = _a.awayTeamId;

      if (match.contumation && match.contumation.advantage) {
        return React.createElement("div", null, match.contumation.advantage === homeTeamId ? match.settings.contumation.score : 0, ' ', "-", ' ', match.contumation.advantage === awayTeamId ? match.settings.contumation.score : 0);
      }
    };

    _this.renderContumatedMatch = function (match) {
      var _a = _this.getTeamsIds(),
          homeTeamId = _a.homeTeamId,
          awayTeamId = _a.awayTeamId;

      var _b = _this.getGoalsByTeams(),
          homeTeamGoals = _b.homeTeamGoals,
          awayTeamGoals = _b.awayTeamGoals;

      var goalsByMatchPart = _this.getGoalsByMatchPart((match.protocol || {
        events: []
      }).events);

      var _c = _this.getShootoutGoals(),
          homeTeamPenaltyGoals = _c.homeTeamGoals,
          awayTeamPenaltyGoals = _c.awayTeamGoals;

      var phases = _this.props.sportSectorsPhases.find(function (i) {
        return i._id === _this.props.match.rules.sport_sector;
      });

      var penaltyPhase = (phases ? phases.items : []).find(function (i) {
        return i._id === 'shootout';
      });
      return React.createElement(React.Fragment, null, match.contumation && match.contumation.keepScore ? React.createElement(React.Fragment, null, React.createElement("div", null, homeTeamGoals + " - " + awayTeamGoals), React.createElement(exports.GoalsByPhases, null, "(", Object.keys(goalsByMatchPart).map(function (phase) {
        return (goalsByMatchPart[phase][homeTeamId] || 0) + ":" + (goalsByMatchPart[phase][awayTeamId] || 0);
      }).join(', '), ")"), (!!homeTeamPenaltyGoals || !!awayTeamPenaltyGoals) && React.createElement(exports.GoalsByPhases, null, !!penaltyPhase && penaltyPhase.label, React.createElement("br", null), homeTeamPenaltyGoals + ":" + awayTeamPenaltyGoals)) : _this.renderContumatedMatchScore(match), React.createElement(exports.MatchStatusIndicator, {
        color: _this.props.theme.color.warning
      }, "Kontumovan\u00E9"));
    };

    _this.renderClosedMatch = function (match) {
      var _a = _this.getTeamsIds(),
          homeTeamId = _a.homeTeamId,
          awayTeamId = _a.awayTeamId;

      var _b = _this.getGoalsByTeams(),
          homeTeamGoals = _b.homeTeamGoals,
          awayTeamGoals = _b.awayTeamGoals;

      var goalsByMatchPart = _this.getGoalsByMatchPart((match.protocol || {
        events: []
      }).events);

      var _c = _this.getShootoutGoals(),
          homeTeamPenaltyGoals = _c.homeTeamGoals,
          awayTeamPenaltyGoals = _c.awayTeamGoals;

      var phases = _this.props.sportSectorsPhases.find(function (i) {
        return i._id === _this.props.match.rules.sport_sector;
      });

      var penaltyPhase = (phases ? phases.items : []).find(function (i) {
        return i._id === 'shootout';
      });
      return React.createElement(React.Fragment, null, React.createElement("div", null, homeTeamGoals + " - " + awayTeamGoals), React.createElement(exports.GoalsByPhases, null, "(", Object.keys(goalsByMatchPart).map(function (phase) {
        return (goalsByMatchPart[phase][homeTeamId] || 0) + ":" + (goalsByMatchPart[phase][awayTeamId] || 0);
      }).join(', '), ")"), (!!homeTeamPenaltyGoals || !!awayTeamPenaltyGoals) && React.createElement(exports.GoalsByPhases, null, !!penaltyPhase && penaltyPhase.label, React.createElement("br", null), homeTeamPenaltyGoals + ":" + awayTeamPenaltyGoals), React.createElement(exports.MatchStatusIndicator, {
        color: _this.props.theme.color.success
      }, "Ukon\u010Den\u00E9"));
    };

    _this.renderFutureMatch = function (match) {
      return React.createElement(React.Fragment, null, React.createElement("div", null, date_fns_1.format(new Date(match.startDate), _config_1["default"].DEFAULT_TIME_FORMAT)), !_this.props.verbose && React.createElement(exports.MatchStatusIndicator, {
        color: _this.props.theme.inactiveColor
      }, date_fns_1.format(new Date(match.startDate), _config_1["default"].DEFAULT_DATE_FORMAT)));
    };

    _this.renderTime = function (activePhase) {
      var currentTime = date_fns_1.addSeconds(new Date(_this.state.live.liveState.startDate), _this.state.live.liveState.seconds);
      var diff = date_fns_1.differenceInSeconds(new Date(currentTime), new Date(_this.state.live.liveState.startDate));

      if (!_this.props.settings.overlapTime && activePhase) {
        var phase = _this.props.settings.phases[activePhase._id];

        if (phase && (_this.props.settings.reverseTime && diff < phase.endTime || !_this.props.settings.reverseTime && diff > phase.endTime)) {
          diff = phase.endTime;
        }
      }

      var minutes = String(Math.ceil(diff / 60)).padStart(2, '0');

      if (!minutes || minutes === 'NaN') {
        return null;
      }

      if (_this.props.settings.displaySeconds) {
        minutes = String(Math.floor(diff / 60)).padStart(2, '0');
        var seconds = String(diff % 60).padStart(2, '0');
        return React.createElement(exports.LiveTime, null, minutes, ":", seconds, " (", !!activePhase && activePhase.label, ")");
      }

      return React.createElement(exports.LiveTime, null, minutes, "' (", !!activePhase && activePhase.label, ")");
    };

    _this.renderLiveMatch = function (match) {
      var phases = _this.props.sportSectorsPhases.find(function (i) {
        return i._id === _this.props.match.rules.sport_sector;
      });

      var _a = _this.getTeamsIds(),
          homeTeamId = _a.homeTeamId,
          awayTeamId = _a.awayTeamId;

      var _b = _this.getGoalsByTeams(),
          homeTeamGoals = _b.homeTeamGoals,
          awayTeamGoals = _b.awayTeamGoals;

      var activePhaseIndex = 0;
      var activePhase = null;

      if (phases) {
        activePhaseIndex = phases.items.findIndex(function (phase) {
          return phase._id === _this.state.live.liveState.phase;
        });
        activePhase = phases.items.find(function (phase) {
          return phase._id === _this.state.live.liveState.phase;
        });
      }

      var goalsByMatchPart = _this.getGoalsByMatchPart(_this.state.live.protocol ? _this.state.live.protocol.events || [] : []);

      var _c = _this.getShootoutGoals(),
          homeTeamPenaltyGoals = _c.homeTeamGoals,
          awayTeamPenaltyGoals = _c.awayTeamGoals;

      var penaltyPhase = (phases ? phases.items : []).find(function (i) {
        return i._id === 'shootout';
      });
      return React.createElement(React.Fragment, null, React.createElement("div", null, homeTeamGoals + " - " + awayTeamGoals), React.createElement(exports.GoalsByPhases, null, "(", Object.keys(goalsByMatchPart).map(function (phase, idx) {
        if (idx <= activePhaseIndex) {
          return (goalsByMatchPart[phase][homeTeamId] || 0) + ":" + (goalsByMatchPart[phase][awayTeamId] || 0);
        }

        return '-:-';
      }).join(', '), ")"), _this.state.live.liveState.phase === 'shootout' && React.createElement(exports.GoalsByPhases, null, !!penaltyPhase && penaltyPhase.label, React.createElement("br", null), homeTeamPenaltyGoals + ":" + awayTeamPenaltyGoals), React.createElement(exports.MatchStatusIndicator, {
        color: _this.props.theme.color.danger
      }, "LIVE"), ' ', _this.renderTime(activePhase));
    };

    _this.getMatchState = function (match) {
      var content = null;
      var isFutureMatch = false;

      if (match.contumation && match.contumation.isContumated) {
        content = _this.renderContumatedMatch(match);
      } else if (match.closed && match.protocol) {
        content = _this.renderClosedMatch(match);
      } else if (!match.closed && !match.liveState && !_this.state.live.liveState.phase) {
        content = _this.renderFutureMatch(match);
        isFutureMatch = true;
      } else {
        content = _this.renderLiveMatch(match);
      }

      if (_this.props.verbose) {
        return React.createElement(exports.LiveScore, {
          compact: !!_this.props.compact
        }, React.createElement(MatchDate, null, date_fns_1.format(new Date(match.startDate), _config_1["default"].DEFAULT_DATE_FORMAT, {
          locale: sk_1["default"]
        })), !isFutureMatch && React.createElement(MatchTime, null, date_fns_1.format(new Date(match.startDate), _config_1["default"].DEFAULT_TIME_FORMAT)), !!match.sportGround && React.createElement(MatchSportGround, null, match.sportGround.sportObjectName), content);
      }

      return React.createElement(exports.LiveScore, {
        compact: !!_this.props.compact
      }, content);
    };

    _this.renderShootersOverview = function () {
      var goalEvents = (_this.props.match.protocol ? _this.props.match.protocol.events : []).filter(function (g) {
        if (g.eventType === 'goal' && g.phase !== 'shootout') {
          return g;
        }
      });
      var goals = goalEvents.reduce(function (acc, i) {
        var _a;

        return tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[i.team] = tslib_1.__spreadArrays(acc[i.team] || [], [i]), _a));
      }, {});

      var homeTeam = _this.getTeam('home');

      var awayTeam = _this.getTeam('away');

      var homeGoals = goals[homeTeam ? homeTeam._id : ''];
      var awayGoals = goals[awayTeam ? awayTeam._id : ''];
      return React.createElement(GoalsOverview, null, React.createElement(GoalsOverviewHomeTeamCol, null, (homeGoals || []).map(function (g) {
        var time = g.eventTime.split(':');
        var seconds = Number(time[1]);
        return React.createElement(GoalsOverviewPlayer, {
          key: g.eventTime
        }, React.createElement(GoalsOverviewPlayerName, null, g.player.name, " ", Number(time[0]) + (seconds > 0 ? 1 : 0), "'"), React.createElement("div", {
          style: {
            display: 'flex',
            alignItems: 'center'
          }
        }, React.createElement(TimeLine_1.Icon, {
          title: "",
          eventType: "goal",
          subType: g.type,
          theme: _this.props.theme,
          size: 15
        })));
      })), React.createElement(GoalsOverviewAwayTeamCol, null, (awayGoals || []).map(function (g) {
        var time = g.eventTime.split(':');
        var seconds = Number(time[1]);
        return React.createElement(GoalsOverviewPlayer, {
          key: g.eventTime
        }, React.createElement(GoalsOverviewPlayerName, null, g.player.name, " ", Number(time[0]) + (seconds > 0 ? 1 : 0), "'"), React.createElement("div", {
          style: {
            display: 'flex',
            alignItems: 'center'
          }
        }, React.createElement(TimeLine_1.Icon, {
          title: "",
          subType: g.type,
          eventType: "goal",
          theme: _this.props.theme,
          size: 15
        })));
      })));
    };

    return _this;
  }

  Match.prototype.componentDidMount = function () {
    var match = this.props.match;

    if (!match.closed && date_fns_1.isEqual(date_fns_1.startOfDay(new Date()), date_fns_1.startOfDay(new Date(match.startDate)))) {
      this.registerLiveScore(match._id);
    }
  };

  Match.prototype.render = function () {
    var _a = this.props,
        match = _a.match,
        lastIndex = _a.lastIndex,
        fullWidth = _a.fullWidth,
        compact = _a.compact,
        verbose = _a.verbose;
    var homeTeam = this.getTeam('home');
    var awayTeam = this.getTeam('away');
    var content = React.createElement(exports.MatchWrapper, {
      fullWidth: fullWidth,
      lastIndex: lastIndex,
      matchSize: this.props.matchSize,
      compact: !!compact,
      verbose: !!verbose
    }, React.createElement("div", {
      style: {
        width: '100%',
        display: 'flex'
      }
    }, React.createElement(exports.Team, {
      align: "left",
      compact: !!compact
    }, homeTeam && homeTeam.organization.logo_public_url && React.createElement(exports.TeamLogo, {
      title: homeTeam ? homeTeam.organization.name : match.teams[0].organization.name,
      alt: homeTeam ? homeTeam.organization.name : match.teams[0].organization.name,
      src: homeTeam ? homeTeam.organization.logo_public_url || '' : match.teams[0].organization.logo_public_url || ''
    }), React.createElement(exports.TeamName, null, homeTeam ? homeTeam.displayName : match.teams[0].name)), this.getMatchState(match), React.createElement(exports.Team, {
      align: "right",
      compact: !!compact
    }, awayTeam && awayTeam.organization.logo_public_url && React.createElement(exports.TeamLogo, {
      title: awayTeam ? awayTeam.organization.name : match.teams[1].organization.name,
      alt: awayTeam ? awayTeam.organization.name : match.teams[1].organization.name,
      src: awayTeam ? awayTeam.organization.logo_public_url || '' : match.teams[1].organization.logo_public_url || ''
    }), React.createElement(exports.TeamName, null, awayTeam ? awayTeam.displayName : match.teams[1].name))), verbose && this.renderShootersOverview());
    return content;
  };

  return Match;
}(React.PureComponent);

exports["default"] = Match;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28;